module.exports = __webpack_public_path__ + "img/1440.ce76f015.jpg";